import React, { useEffect, useRef, useCallback, useState } from 'react';
import { Pannellum } from 'pannellum-react';
import Styles from '../../../src/Css/View360/Interior360.module.css';
import InteriorMobileToggleHandler from './HotspotToggleHandler/InteriorMobileToggleHandler';
import { checkIsV2 } from '../../utils/getAppVersion';
import { amplitudeEvents } from '../../utils/utilityFunctions';



const InteriorIframe = ({ handleOnLoad, state, isMobileView, hotspotDataInterior, ToggleInteriorHotspots , hotspotImageId }) => {

  const [hotspotsJson, setHotspotsJson] = useState(hotspotDataInterior);
  const [handlerMobileHotspot, setHandlerMobileHotspot] = useState(true);
  const [isAutoRotating, setIsAutoRotating] = useState(true);
  const [isImageIdValid , setIsImageIdValid] = useState(false);
  const isV2 = checkIsV2()

  const toggleHotspotVisibility = useCallback(() => {
    const shouldHideHotspots = ToggleInteriorHotspots || !handlerMobileHotspot;
    const visibility = shouldHideHotspots ? 'hidden' : 'visible';
    document.querySelectorAll('.pnlm-hotspot-base').forEach((e) => {
        e.style.visibility = visibility;
    });
}, [ToggleInteriorHotspots, handlerMobileHotspot]);

  const convertCoordinates = (x, y) => {
    const imgWidth = 100;
    const imgHeight = 100;
    const yaw = (x / imgWidth) * 360 - 180;
    const theta = (y / imgHeight) * Math.PI;
    const pitch = (Math.PI / 2 - theta) * (180 / Math.PI);
    return {
      yaw: yaw ,
      pitch: pitch
    };
  };


  let originalData = []
  const getFilteredData = (response) => {
    if (hotspotsJson.length !== 0) {
      // console.log("RETURNED FROM IF", originalData)
      return originalData;
    }
    const interior_array = response.data.hotspots[0].interior_tagged_images;
    // console.log(interior_array, "DATA Interior Array");

    // Check if `interior_array` is an array and get the first element, otherwise assign an empty array
    const array = Array.isArray(interior_array) ? interior_array[0] : [];
    // console.log(array, "DATA Array");

    // Extract the `hotspots` from the first element of `interior_array`
    const h = array.hotspots;
    // console.log(h, "DATA h");

    // Filter the `hotspots` to only include those with "Seats" in the reasons
    const filteredHotspots = h.filter(hotspot => !hotspot.reasons.includes("Seats"));
    // console.log(filteredHotspots, "DATA filteredHotspots");

    // Create a new object with the updated `hotspots` field
    const newHotspotsObject = [{
      ...response.data.hotspots[0], // Spread the first hotspot object to preserve all other fields
      interior_tagged_images: [     // Replace the `interior_tagged_images` with the updated hotspots
        {
          ...array,  // Spread the first element of `interior_array` to preserve other fields
          hotspots: filteredHotspots // Update the `hotspots` with the filtered ones
        }
      ]
    }];
    // console.log("RETURNED FROM FUNC", newHotspotsObject)
    return newHotspotsObject;
  }
  // console.log(hotspotsJson , " This is from InteriorIframe")
  const queryParams = new URLSearchParams(window.location.search);

  // useEffect(() => {
  //   const fetchHotspots = async () => {
  //     try {
  //       const skuId = queryParams.get('sku_id');
  //       // console.log('This is try SKU ID From Interior:', skuId);

  //       // Use the fetched skuId in your API request
  //       const response = await axios.get(`https://api.spyne.ai/api/v1/hotspot/get-hotspots?skuId=${skuId}`);
  //       // console.log(response.data, "This is the response Data");

  //       setHotspotsJson(response.data.hotspots);
  //     } catch (error) {
  //       console.error('Error fetching the data:', error);
  //     }
  //   };

  //   fetchHotspots();
  // }, []);

    useEffect(() => {
    // Assuming you want to do something with the prop data, like merging it with API data
    if (hotspotDataInterior) {
      // Handle the prop data, e.g., merge it with fetched hotspots
      // Example: merge and eliminate duplicates, this is just a basic example
      setHotspotsJson(prev => [...new Set([...prev, ...hotspotDataInterior])]);
    }
  }, [hotspotDataInterior]); // Depend on hotspotDataInterior prop



  const viewerRef = useRef(null);




  // hotspotsJson[0]?.interior_tagged_images[0]?.hotspots || [].forEach(hotspot => {
  //   console.log("Coordinates: ", hotspot.coordinates);
  //   console.log("This is X cordinate and Y cordinate", hotspot.coordinates.x, hotspot.coordinates.y)
  //   console.log("Hotspot ID: ", hotspot.hotspot_id);
  //   console.log("Type: ", hotspot.type);
  //   console.log("Hotspot Icon: ", hotspot.hotspot_icon);
  //   console.log("Reasons: ", hotspot.reasons.join(", "));
  //   console.log("Focus Image URL: ", hotspot.focus_image_url);
  //   console.log("ID: ", hotspot._id);
  //   console.log("---------------");
  // });


  //  Amplitude events for mouse drag 


  
  const isEngagementStarted = useRef(false);
  const engagementTimeout = useRef(null);
  const engagementStartTime = useRef(null); 
  const isDragging = useRef(false);
  const containerRef = useRef(null); 
  
  
  let sessionId = `session_${Math.random().toString(36).substring(2, 11)}`;


  // Capturing the amplitude events 
  useEffect(() => {
    const handleEngagementStart = () => {
        if (!isEngagementStarted?.current) {
            isEngagementStarted.current = true;
            engagementStartTime.current = new Date();

            amplitudeEvents({
                event: 'iframe_interior_engage_started',
                customAmplitudeEvents: {
                    iframe_session_id: sessionId,
                    sku_id: state?.skuId || state?.skuIdForDownload,
                    enterprise_id: state?.enterpriseIdForDownload,
                    skuName: state?.skuName
                }
            });
        }

        resetEngagementTimeout();
    };

    const handleEngagementEnd = () => {
        if (isEngagementStarted.current) {
            isEngagementStarted.current = false;

            const engagementEndTime = new Date();
            const durationMs = engagementEndTime - engagementStartTime.current;
            const engagementDurationSec = durationMs / 1000;
            
            amplitudeEvents({
                event: 'iframe_interior_engage_end',
                customAmplitudeEvents: {
                    iframe_session_id: sessionId,
                    sku_id: state?.skuId || state?.skuIdForDownload,
                    enterprise_id: state?.enterpriseIdForDownload,
                    skuName: state?.skuName,
                    engagementDuration: engagementDurationSec - 5 + '  Seconds'
                }
            });

            engagementStartTime.current = null;
        }
    };

    const resetEngagementTimeout = () => {
        if (engagementTimeout?.current) {
            clearTimeout(engagementTimeout.current);
        }

        engagementTimeout.current = setTimeout(() => {
            handleEngagementEnd();
        }, 5000);
    };

    const handleMouseDown = () => {
        if (!isDragging?.current) {
            isDragging.current = true;
            handleEngagementStart();
        }
    };

    const handleMouseUp = () => {
        if (isDragging?.current) {
            isDragging.current = false;
            resetEngagementTimeout();
        }
    };

    const handleMouseLeave = () => {
        if (isDragging?.current) {
            isDragging.current = false;
            resetEngagementTimeout();
        }
    };

    const container = containerRef.current;

    container.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);
    container.addEventListener('mouseleave', handleMouseLeave);

    // Cleanup function
    return () => {
        container.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('mouseup', handleMouseUp);
        container.removeEventListener('mouseleave', handleMouseLeave);

        if (engagementTimeout?.current) {
            clearTimeout(engagementTimeout?.current);
        }

        if (isEngagementStarted?.current) {
            handleEngagementEnd();
        }
    };
}, [
    sessionId,
    state?.skuIdForDownload,
    state?.enterpriseIdForDownload,
    amplitudeEvents
]);






  
  const validHotspots = Array.isArray(hotspotsJson) && hotspotsJson.length > 0 ? hotspotsJson : null;

  const hotspotData = (hotspotsJson || []).map(hotspot => ({
    focus_image_url: hotspot.focus_image_url,
    type: hotspot.reasons.join(', ') // Join the reasons into a comma-separated string
  }));

  // console.log(hotspotData , "this is hotspot data")

  // Console log the result to see the content of hotspotData
  // console.log('Hotspot Data Here all:', hotspotData);




  // console.log(hotspots);
  const spanRef = useRef(null);

  useEffect(() => {
    // Your existing useEffect logic
  }, [state?.url]);

  useEffect(() => {
    const removeInOutDivs = () => {
      const divsToRemove = document.querySelectorAll('div.in, div.out');
      divsToRemove.forEach(div => {
        div.remove();
      });
    };



    // Set up a MutationObserver to monitor DOM changes
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Trigger the removal function whenever the DOM is updated
          removeInOutDivs();
        }
      }

    });

    // Observe the entire document for changes
    observer.observe(document.body, {
      childList: true, // Listen for changes in child elements
      subtree: true    // Listen for changes in all descendants
    });

    // Run the removal function initially to clear existing elements
    removeInOutDivs();

    // Cleanup function to disconnect the observer when the component unmounts
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    toggleHotspotVisibility();

    const observer = new MutationObserver((mutations) => {
        if (mutations.some(mutation => mutation.type === 'childList' || mutation.type === 'attributes')) {
            toggleHotspotVisibility();
        }
    });

    const hotspotContainer = document.querySelector('.pnlm-container');
    if (hotspotContainer) {
        observer.observe(hotspotContainer, {
            attributes: true,
            childList: true,
            subtree: true,
        });
    }

    return () => observer.disconnect();
}, [toggleHotspotVisibility]);



  // useEffect(() => {
  //   if (hotSpotRef.current && spanRef.current) {
  //     const hotSpotDiv = hotSpotRef.current;
  //     const span = spanRef.current;

  //     span.style.width = span.scrollWidth - 20 + 'px';
  //     span.style.marginLeft = -(span.scrollWidth - hotSpotDiv.offsetWidth) / 2 + 'px';
  //     span.style.marginTop = -span.scrollHeight - 12 + 'px';
  //   }
  // }, [hotspots]); // Dependency on hotspots or args

  

  const handleError = (e) => {
    console.error(e);
  };

  const [tooltipContent, setTooltipContent] = useState('');
  const [tooltipStyle, setTooltipStyle] = useState({});

  useEffect(() => {
    // Clean up tooltips if needed
    return () => {
      setTooltipContent('');
      setTooltipStyle({});
    };
  }, []);


  useEffect(() => {
    if (hotspotImageId === state?.selectedUrl.image_id) {
      setIsImageIdValid(true);
    }
    else setIsImageIdValid(false);
  }, [hotspotImageId, state?.selectedUrl.image_id]);
  


  function setupHotspotTooltip(hotSpotDiv, focus_image, text, textSize = '14px', width = '10px', height = 'auto', textColor = 'black', background = 'white', borderRadius = '2rem') {
    // console.log("Setting up hotspot tooltip");
    let currentIndex = 0;  // Keep track of the current image index

    // Styling and animations
    const style = document.createElement('style');
    style.textContent = `
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
        }
        .tooltip-content {
            animation: fadeIn 0.3s ease-out;
            position: relative;
        }
        @keyframes drawCircle {
            to { stroke-dashoffset: 0; }
        }
        .circle {
            stroke-dasharray: 103.67;
            stroke-dashoffset: 103.67;
            animation: drawCircle 0.3s linear forwards;
        }
        @keyframes ripple {
            0% { opacity: 1; transform: scale(0); }
            100% { opacity: 0; transform: scale(2); }
        }
        .ripple {
            position: absolute;
            border-radius: 50%;
            background-color: #5465FF99;
            width: 100%;
            height: 100%;
            left: -3px;
            top: -4px;
            animation: ripple 1.5s ease-out infinite;
            z-index: 0;
        }
        .big-div, .expanded-div {
            position: fixed;
            top: 20px;
            right: 20px;
            width: 250px;
            height: 150px;
            background-color: white;
            z-index: 1000;
            border-radius: 10px;
            box-shadow: 0 0 20px rgba(0,0,0,0.2);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            text-align: center;
            padding: 10px;
        }
        .expand-button, .close-button {
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
        }
        @keyframes drawLine {
            from { stroke-dashoffset: 1000; }
            to { stroke-dashoffset: 0; }
        }
        .connection-line {
            stroke: white;
            stroke-width: 2;
            stroke-dasharray: 1000;
            stroke-dashoffset: 1000;
            animation: drawLine 0.5s linear forwards;
        }
    `;
    document.head.appendChild(style);

    // Function to disable keyboard input
    function disableKeyboardInput() {
      // console.log("Disabling keyboard input");
      window.addEventListener('keydown', preventKeyboardInput, true);
      window.addEventListener('keyup', preventKeyboardInput, true);
    }

    // Function to enable keyboard input
    function enableKeyboardInput() {
      // console.log("Enabling keyboard input");
      window.removeEventListener('keydown', preventKeyboardInput, true);
      window.removeEventListener('keyup', preventKeyboardInput, true);
    }

    // Function to prevent keyboard input
    function preventKeyboardInput(e) {
      e.stopPropagation();
      e.preventDefault();
    }

    // Function to clear existing hotspot elements
    function clearPreviousHotspot() {
      // console.log("Clearing previous hotspot");
      const existingBigDiv = document.querySelector('.big-div');
      const existingSvg = document.querySelector('svg.hotspot-svg');
      const existingOverlay = document.querySelector('.background-overlay');
      const existingExpandedDiv = document.querySelector('.expanded-div');

      if (existingBigDiv) {
        // console.log("Removing existing big div");
        existingBigDiv.remove();
      }
      if (existingSvg) {
        // console.log("Removing existing SVG");
        existingSvg.remove();
      }
      if (existingOverlay) {
        // console.log("Removing existing overlay");
        existingOverlay.remove();
      }
      if (existingExpandedDiv) {
        // console.log("Removing existing expanded div");
        existingExpandedDiv.remove();
      }
      enableKeyboardInput(); // Re-enable keyboard input when overlays are removed
    }

    // Function to create a ripple effect
    function createRipple() {
      // console.log("Creating ripple effect");
      const ripple = document.createElement('span');
      ripple.classList.add('ripple');

      // Insert the ripple as the first child of hotSpotDiv, so it is behind other elements
      hotSpotDiv.insertBefore(ripple, hotSpotDiv.firstChild);

      // Ensure the ripple has a lower z-index than the SVG
      ripple.style.zIndex = '0'; // Lower z-index than the SVG
    }

    // Function to create a tooltip
    function createTooltip() {
      // console.log("Creating tooltip");
      if (hotSpotDiv.querySelector('.tooltip-content')) return;

      const tooltipDiv = document.createElement('div');
      tooltipDiv.className = 'tooltip-content';
      tooltipDiv.innerHTML = text;

      tooltipDiv.style.color = textColor;
      tooltipDiv.style.backgroundColor = background;
      tooltipDiv.style.borderRadius = borderRadius;
      tooltipDiv.style.padding = '2px';
      tooltipDiv.style.maxWidth = '150px';
      tooltipDiv.style.width = 'auto';
      tooltipDiv.style.height = 'auto';
      tooltipDiv.style.fontSize = textSize;
      tooltipDiv.style.zIndex = '1';

      document.body.appendChild(tooltipDiv);

      const contentWidth = tooltipDiv.offsetWidth;
      const contentHeight = tooltipDiv.offsetHeight;

      document.body.removeChild(tooltipDiv);

      tooltipDiv.style.width = `${Math.max(contentWidth, parseInt(width))}px`;
      tooltipDiv.style.height = `${Math.max(contentHeight, parseInt(height))}px`;

      hotSpotDiv.appendChild(tooltipDiv);

      tooltipDiv.style.marginLeft = `${-(tooltipDiv.offsetWidth - hotSpotDiv.offsetWidth) / 2}px`;
      tooltipDiv.style.marginTop = `${-tooltipDiv.offsetHeight - 12}px`;

      tooltipDiv.dataset.tooltipId = 'hotspot-tooltip';

      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", "100%");
      svg.setAttribute("height", "100%");
      svg.style.position = "absolute";
      svg.style.top = "-3px";
      svg.style.left = "-3px";
      svg.style.pointerEvents = "none";
      svg.style.zIndex = "1"; // Ensure the SVG is above the ripple effect

      const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      circle.setAttribute("cx", "50%");
      circle.setAttribute("cy", "50%");
      circle.setAttribute("r", "16.5");
      circle.setAttribute("fill-opacity", "0");
      circle.setAttribute("stroke", "#fff");
      circle.setAttribute("stroke-width", "1");
      circle.classList.add("circle");

      svg.appendChild(circle);
      hotSpotDiv.appendChild(svg);
    }


    // Function to remove tooltip
    function removeTooltip() {
      // console.log("Removing tooltip");
      const tooltipDiv = hotSpotDiv.querySelector('.tooltip-content');
      const svg = hotSpotDiv.querySelector('svg');
      if (tooltipDiv && hotSpotDiv.contains(tooltipDiv)) {
        hotSpotDiv.removeChild(tooltipDiv);
      }
      if (svg && hotSpotDiv.contains(svg)) {
        hotSpotDiv.removeChild(svg);
      }
    }

    // Function to create a background overlay
    function createBackgroundOverlay() {
      // console.log("Creating background overlay");
      const overlay = document.createElement('div');
      overlay.className = 'background-overlay';
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      overlay.style.zIndex = '998';
      document.body.appendChild(overlay);
      disableKeyboardInput(); // Disable keyboard input when the overlay is created
      return overlay;
    }



    // Function to create and manage the big-div including a close handler
    function createBigDiv(focus_image, text, initialIndex) {
      // console.log("Creating big div");
      clearPreviousHotspot();
      let currentIndex = initialIndex;

      const overlay = createBackgroundOverlay();

      const bigDiv = document.createElement('div');
      bigDiv.className = 'big-div';
      bigDiv.style.height = "10rem"
      bigDiv.style.width = "20rem"
      bigDiv.style.padding = '0';
      bigDiv.style.margin = '20px';
      bigDiv.style.overflow = 'hidden';
      bigDiv.style.display = 'flex';
      bigDiv.style.flexDirection = 'column'; // Set flex direction to column to stack elements vertically
      bigDiv.style.alignItems = 'center';
      bigDiv.style.justifyContent = 'center';
      bigDiv.style.position = 'fixed';
      bigDiv.style.top = '0';
      bigDiv.style.right = '0';
      bigDiv.style.zIndex = '1000';

      // Create and style the header for bigDiv
      const bigDivHeader = document.createElement('div');
      bigDivHeader.style.width = '100%';
      bigDivHeader.style.padding = '10px 20px';
      bigDivHeader.style.backgroundColor = 'rgba(0, 0, 0, 0.9)'; // Lowered opacity for more transparency
      bigDivHeader.style.color = 'white';
      bigDivHeader.style.marginTop = '2rem';
      bigDivHeader.style.fontSize = '14px';
      bigDivHeader.style.textAlign = 'center';
      bigDivHeader.innerText = text;

      // Prevent closing when clicking the header
      bigDivHeader.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      const imgElement = document.createElement('img');
      imgElement.src = focus_image;
      imgElement.alt = 'Image';
      imgElement.style.width = '100%';
      imgElement.style.height = '100%';
      imgElement.style.objectFit = 'cover';
      imgElement.style.display = 'block';

      bigDiv.appendChild(bigDivHeader); // Append the header first
      bigDiv.appendChild(imgElement); // Then the image
      document.body.appendChild(bigDiv);

      const closeSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      closeSvg.setAttribute("width", "28");
      closeSvg.setAttribute("height", "28");
      closeSvg.setAttribute("viewBox", "0 0 40 41");
      closeSvg.innerHTML = `
          <rect y="0.9375" width="40" height="40" rx="20" fill="black" fill-opacity="0.6"></rect>
          <path d="M20.0019 22.5345L14.4126 28.1238C14.2035 28.3329 13.9373 28.4375 13.6141 28.4375C13.2909 28.4375 13.0248 28.3329 12.8156 28.1238C12.6065 27.9147 12.502 27.6485 12.502 27.3253C12.502 27.0021 12.6065 26.736 12.8156 26.5269L18.405 20.9375L12.8156 15.3481C12.6065 15.139 12.502 14.8729 12.502 14.5497C12.502 14.2265 12.6065 13.9603 12.8156 13.7512C13.0248 13.5421 13.2909 13.4375 13.6141 13.4375C13.9373 13.4375 14.2035 13.5421 14.4126 13.7512L20.0019 19.3405L25.5913 13.7512C25.8004 13.5421 26.0666 13.4375 26.3898 13.4375C26.713 13.4375 26.9791 13.5421 27.1883 13.7512C27.3974 13.9603 27.5019 14.2265 27.5019 14.5497C27.5019 14.8729 27.3974 15.139 27.1883 15.3481L21.5989 20.9375L27.1883 26.5269C27.3974 26.736 27.5019 27.0021 27.5019 27.3253C27.5019 27.6485 27.3974 27.9147 27.1883 28.1238C26.9791 28.3329 26.713 28.4375 26.3898 28.4375C26.0666 28.4375 25.8004 28.3329 25.5913 28.1238L20.0019 22.5345Z" fill="white"></path>
      `;
      closeSvg.classList.add('close-button');
      closeSvg.style.fill = "none";
      closeSvg.style.position = "absolute";
      closeSvg.style.top = "5px";
      closeSvg.style.left = "5px"; // Move from right to left
      closeSvg.style.right = "unset"; // Remove the right position setting
      closeSvg.style.cursor = "pointer";
      closeSvg.style.zIndex = "1501"; // Ensure it's above the expanded view
      bigDiv.appendChild(closeSvg);

      // Adding SVG button to expand view
      const expandSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      expandSvg.setAttribute("width", "24");
      expandSvg.setAttribute("height", "25");
      expandSvg.setAttribute("viewBox", "0 0 24 25");
      expandSvg.setAttribute("fill", "none");
      expandSvg.innerHTML = `
          <rect y="0.304688" width="24" height="24" rx="12" fill="black" fill-opacity="0.4"></rect>
          <path d="M8.56295 15.0489L10.285 13.3268C10.3823 13.2295 10.4967 13.1808 10.628 13.1808C10.7593 13.1808 10.8737 13.2295 10.971 13.3268C11.0683 13.4241 11.117 13.5385 11.117 13.6698C11.117 13.8011 11.0683 13.9154 10.971 14.0128L9.25596 15.7278L10.6597 15.7208C10.7957 15.7208 10.9124 15.768 11.0097 15.8624C11.107 15.9568 11.1557 16.0749 11.1557 16.2168C11.1557 16.3587 11.1085 16.4768 11.0141 16.5712C10.9197 16.6656 10.8016 16.7128 10.6597 16.7128L8.16368 16.7128C8.07807 16.7128 8.00273 16.6978 7.93765 16.6679C7.87257 16.638 7.81248 16.5955 7.75736 16.5404C7.70224 16.4853 7.65974 16.4252 7.62984 16.3601C7.59993 16.2951 7.58498 16.2197 7.58499 16.1341L7.58499 13.624C7.58498 13.488 7.63218 13.3737 7.72657 13.2811C7.82096 13.1884 7.93911 13.1421 8.081 13.1421C8.22288 13.1421 8.33985 13.1881 8.4319 13.2802C8.52396 13.3722 8.56998 13.4892 8.56998 13.6311L8.56295 15.0489ZM8.56998 9.55374L8.57702 10.9574C8.57702 11.0935 8.52983 11.2101 8.43543 11.3075C8.34102 11.4048 8.22288 11.4535 8.081 11.4535C7.93911 11.4535 7.82096 11.4063 7.72657 11.3119C7.63218 11.2175 7.58498 11.0993 7.58498 10.9574L7.58499 8.46146C7.58498 8.37585 7.59993 8.30051 7.62984 8.23543C7.65974 8.17035 7.70224 8.11026 7.75736 8.05514C7.81248 8.00002 7.87257 7.95752 7.93765 7.92762C8.00273 7.89771 8.07807 7.88276 8.16368 7.88277L10.6597 7.88276C10.7957 7.88276 10.9112 7.92879 11.0062 8.02084C11.1012 8.11289 11.1486 8.22985 11.1486 8.37174C11.1486 8.51363 11.1026 8.6306 11.0106 8.72265C10.9185 8.81471 10.8015 8.86073 10.6597 8.86072L9.24893 8.86073L10.971 10.5828C11.0683 10.6801 11.117 10.7944 11.117 10.9258C11.117 11.0571 11.0683 11.1714 10.971 11.2688C10.8737 11.3661 10.7593 11.4148 10.628 11.4148C10.4967 11.4148 10.3823 11.3661 10.285 11.2688L8.56998 9.55374ZM14.7511 15.7348L13.029 14.0128C12.9317 13.9154 12.883 13.8011 12.883 13.6698C12.883 13.5385 12.9317 13.4241 13.029 13.3268C13.1263 13.2295 13.2407 13.1808 13.372 13.1808C13.5033 13.1808 13.6177 13.2295 13.715 13.3268L15.43 15.0418L15.423 13.6381C15.423 13.5021 15.4702 13.3854 15.5646 13.2881C15.659 13.1908 15.7771 13.1421 15.919 13.1421C16.0609 13.1421 16.179 13.1893 16.2734 13.2837C16.3678 13.3781 16.415 13.4962 16.415 13.6381L16.415 16.1341C16.415 16.2197 16.4001 16.2951 16.3702 16.3601C16.3403 16.4252 16.2978 16.4853 16.2426 16.5404C16.1875 16.5955 16.1274 16.638 16.0623 16.6679C15.9973 16.6978 15.9219 16.7128 15.8363 16.7128L13.3263 16.7128C13.1902 16.7128 13.0771 16.6668 12.9868 16.5747C12.8965 16.4827 12.8514 16.3657 12.8514 16.2238C12.8514 16.0819 12.8974 15.965 12.9894 15.8729C13.0815 15.7809 13.1985 15.7348 13.3403 15.7348L14.7511 15.7348ZM14.7511 8.86073H13.3263C13.1902 8.86073 13.0759 8.81588 12.9833 8.72618C12.8906 8.63646 12.8443 8.52066 12.8443 8.37878C12.8443 8.23689 12.8903 8.11992 12.9824 8.02787C13.0744 7.93582 13.1914 7.8898 13.3333 7.8898L15.8363 7.88277C15.9219 7.88276 15.9973 7.89771 16.0623 7.92762C16.1274 7.95752 16.1875 8.00002 16.2426 8.05514C16.2978 8.11026 16.3403 8.17035 16.3702 8.23543C16.4001 8.30051 16.415 8.37585 16.415 8.46146L16.415 10.9715C16.415 11.1075 16.3702 11.2219 16.2805 11.3145C16.1908 11.4071 16.075 11.4535 15.9331 11.4535C15.7912 11.4535 15.6742 11.4074 15.5822 11.3154C15.4901 11.2233 15.4441 11.1064 15.4441 10.9645L15.437 9.54671L13.715 11.2688C13.6177 11.3661 13.5033 11.4148 13.372 11.4148C13.2407 11.4148 13.1263 11.3661 13.029 11.2688C12.9317 11.1714 12.883 11.0571 12.883 10.9258C12.883 10.7944 12.9317 10.6801 13.029 10.5828L14.7511 8.86073Z" fill="white"></path>
      `;
      expandSvg.classList.add('expand-button');
      expandSvg.style.position = 'absolute';
      expandSvg.style.top = '5px';
      expandSvg.style.right = '5px';
      expandSvg.style.zIndex = '1001';  // Ensure the expand button is on top of the bigDiv
      expandSvg.style.cursor = 'pointer';
      bigDiv.appendChild(expandSvg);

      // Event handler for the expand button to create a larger view
      expandSvg.addEventListener('click', (e) => {
        e.stopPropagation();  // Prevent the event from bubbling up and closing the view immediately
        console.log("Expanding view");

        const expandedOverlay = createBackgroundOverlay();
        expandedOverlay.style.zIndex = '1499'; // Ensure the overlay is behind the expanded view but above everything else

        const expandedDiv = document.createElement('div');
        expandedDiv.className = 'expanded-div';
        expandedDiv.style.position = 'fixed';
        expandedDiv.style.top = '50%';
        expandedDiv.style.left = '50%';
        expandedDiv.style.transform = 'translate(-50%, -50%)';
        expandedDiv.style.width = '50%'; // Adjust width as needed
        expandedDiv.style.height = 'auto'; // Let height adjust to content
        expandedDiv.style.maxHeight = '80%'; // Limit maximum height
        expandedDiv.style.background = 'transparent';
        expandedDiv.style.zIndex = '1500';
        expandedDiv.style.display = 'flex';
        expandedDiv.style.flexDirection = 'column';
        expandedDiv.style.overflow = 'hidden';
        expandedDiv.style.padding = '0';
        expandedDiv.style.margin = '0';

        // Create header
        const header = document.createElement('div');
        header.style.width = '100%';
        header.style.padding = '10px 20px';
        header.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        header.style.color = 'white';
        header.style.fontSize = '18px';
        header.style.textAlign = 'center';
        header.innerText = text;

        // Prevent closing when clicking the header
        header.addEventListener('click', (e) => {
          e.stopPropagation();
        });

        // Create left button
        const leftButton = document.createElement('button');
        leftButton.innerText = '<';
        leftButton.style.position = 'absolute';
        leftButton.style.left = '10px';
        leftButton.style.top = '50%';
        leftButton.style.transform = 'translateY(-50%)';
        leftButton.style.zIndex = '1501';
        leftButton.style.cursor = 'pointer';
        leftButton.style.background = 'rgba(0, 0, 0, 0.5)';
        leftButton.style.border = 'none';
        leftButton.style.color = 'white';
        leftButton.style.fontSize = '20px';
        leftButton.style.padding = '10px';

        // Create right button
        const rightButton = document.createElement('button');
        rightButton.innerText = '>';
        rightButton.style.position = 'absolute';
        rightButton.style.right = '10px';
        rightButton.style.top = '50%';
        rightButton.style.transform = 'translateY(-50%)';
        rightButton.style.zIndex = '1501';
        rightButton.style.cursor = 'pointer';
        rightButton.style.background = 'rgba(0, 0, 0, 0.5)';
        rightButton.style.border = 'none';
        rightButton.style.color = 'white';
        rightButton.style.fontSize = '20px';
        rightButton.style.padding = '10px';

        // Create image container
        const imageContainer = document.createElement('div');
        imageContainer.style.width = '100%';
        imageContainer.style.height = '70%';
        imageContainer.style.display = 'flex';
        imageContainer.style.alignItems = 'center';
        imageContainer.style.justifyContent = 'center';
        imageContainer.style.overflow = 'hidden';

        const expandedImg = document.createElement('img');
        expandedImg.src = focus_image;
        expandedImg.alt = 'Expanded Image';
        expandedImg.style.width = '100%';
        expandedImg.style.height = 'auto';
        expandedImg.style.objectFit = 'contain';

        imageContainer.appendChild(expandedImg);

        // Append header and image container to expandedDiv
        expandedDiv.appendChild(header);
        expandedDiv.appendChild(imageContainer);

        document.body.appendChild(expandedDiv);

        const updateExpandedView = (hotspotData) => {
          // console.log('Updating view. Current index:', currentIndex);

          if (Array.isArray(hotspotData) && hotspotData.length > 0) {
            if (currentIndex >= 0 && currentIndex < hotspotData.length) {
              if (hotspotData[currentIndex] && hotspotData[currentIndex].focus_image_url && hotspotData[currentIndex].type) {
                expandedImg.src = hotspotData[currentIndex].focus_image_url;
                header.innerText = hotspotData[currentIndex].type;
              } else {
                console.error('Invalid hotspot data at index:', currentIndex);
                expandedImg.src = 'defaultImagePath';  // Replace with a default image path if needed
                header.innerText = 'Unknown type';
              }
            } else {
              console.error('currentIndex is out of bounds:', currentIndex);
            }
          } else {
            console.error('hotspotData is not a valid array or is empty');
          }
        };


        // Event listeners for navigation buttons
        leftButton.addEventListener('click', (e) => {
          e.stopPropagation();
          if (currentIndex > 0) {
            currentIndex--;
          } else {
            currentIndex = hotspotData.length - 1;
          }
          updateExpandedView(hotspotData);
        });

        rightButton.addEventListener('click', (e) => {
          e.stopPropagation();
          if (currentIndex < hotspotData.length - 1) {
            currentIndex++;
          } else {
            currentIndex = 0;
          }
          updateExpandedView(hotspotData);
        });

        expandedDiv.appendChild(leftButton);
        expandedDiv.appendChild(rightButton);

        // Close button for the expanded view
        const closeSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        closeSvg.setAttribute("width", "34");
        closeSvg.setAttribute("height", "34");
        closeSvg.setAttribute("viewBox", "0 0 40 41");
        closeSvg.innerHTML = `
            <rect y="0.9375" width="40" height="40" rx="20" fill="black" fill-opacity="0.6"></rect>
            <path d="M20.0019 22.5345L14.4126 28.1238C14.2035 28.3329 13.9373 28.4375 13.6141 28.4375C13.2909 28.4375 13.0248 28.3329 12.8156 28.1238C12.6065 27.9147 12.502 27.6485 12.502 27.3253C12.502 27.0021 12.6065 26.736 12.8156 26.5269L18.405 20.9375L12.8156 15.3481C12.6065 15.139 12.502 14.8729 12.502 14.5497C12.502 14.2265 12.6065 13.9603 12.8156 13.7512C13.0248 13.5421 13.2909 13.4375 13.6141 13.4375C13.9373 13.4375 14.2035 13.5421 14.4126 13.7512L20.0019 19.3405L25.5913 13.7512C25.8004 13.5421 26.0666 13.4375 26.3898 13.4375C26.713 13.4375 26.9791 13.5421 27.1883 13.7512C27.3974 13.9603 27.5019 14.2265 27.5019 14.5497C27.5019 14.8729 27.3974 15.139 27.1883 15.3481L21.5989 20.9375L27.1883 26.5269C27.3974 26.736 27.5019 27.0021 27.5019 27.3253C27.5019 27.6485 27.3974 27.9147 27.1883 28.1238C26.9791 28.3329 26.713 28.4375 26.3898 28.4375C26.0666 28.4375 25.8004 28.3329 25.5913 28.1238L20.0019 22.5345Z" fill="white"></path>
        `;
        closeSvg.classList.add('close-button');
        closeSvg.style.fill = "none";
        closeSvg.style.position = "absolute";
        closeSvg.style.top = "5px";
        closeSvg.style.right = "5px";
        closeSvg.style.cursor = "pointer";
        closeSvg.style.zIndex = "1501"; // Ensure it's above the expanded view
        expandedDiv.appendChild(closeSvg);

        const clearExpandedView = () => {
          expandedOverlay.remove();
          expandedDiv.remove();
        };

        closeSvg.addEventListener('click', (e) => {
          e.stopPropagation();
          clearExpandedView();
        });

        // Close the expanded view if clicking outside of the image or header
        expandedOverlay.addEventListener('click', clearExpandedView);
        expandedImg.addEventListener('click', (e) => {
          e.stopPropagation(); // Prevent closing if the image itself is clicked
        });
      });



      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.style.position = "fixed";
      svg.style.top = "0";
      svg.style.left = "0";
      svg.style.width = "100%";
      svg.style.height = "100%";
      svg.style.pointerEvents = "none";
      svg.style.zIndex = "999";
      svg.classList.add("hotspot-svg");

      const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      const hotspotRect = hotSpotDiv.getBoundingClientRect();
      const circleCenterX = hotspotRect.left + hotspotRect.width / 2;
      const circleCenterY = hotspotRect.top + hotspotRect.height / 2;
      const circleRadius = 16.5;
      circle.setAttribute("cx", circleCenterX);
      circle.setAttribute("cy", circleCenterY);
      circle.setAttribute("r", circleRadius);
      circle.setAttribute("fill-opacity", "0");
      circle.setAttribute("stroke", "#fff");
      circle.setAttribute("stroke-width", "1");
      circle.classList.add("circle");

      // Calculate the starting point of the line (on the circle's edge)
      const angle = Math.atan2(bigDiv.offsetTop + bigDiv.offsetHeight - circleCenterY, bigDiv.offsetLeft - circleCenterX);
      const startX = circleCenterX + circleRadius * Math.cos(angle);
      const startY = circleCenterY + circleRadius * Math.sin(angle);

      const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
      line.setAttribute("x1", startX);
      line.setAttribute("y1", startY);
      line.setAttribute("x2", bigDiv.offsetLeft);
      line.setAttribute("y2", bigDiv.offsetTop + bigDiv.offsetHeight);
      line.classList.add("connection-line");

      svg.appendChild(circle, svg.style.top = "-3px", svg.style.left = "-3px");
      svg.appendChild(line);
      document.body.appendChild(svg);

      const closeHandler = (e) => {
        // console.log("Close handler called");
        e.stopPropagation();
        clearPreviousHotspot();
        document.removeEventListener('click', closeHandler);
      };

      bigDiv.addEventListener('click', closeHandler);
      document.addEventListener('click', closeHandler);

      // console.log("Big div created and added to the document");
    }



    // Adding event listeners for various interactions
    // console.log("Adding event listeners to hotSpotDiv");
    hotSpotDiv.addEventListener('mouseover', createTooltip);
    hotSpotDiv.addEventListener('mouseleave', removeTooltip);
    hotSpotDiv.addEventListener('click', (e) => {
      // console.log("Hotspot clicked");
      e.stopPropagation();

      // Find the index of the current hotspot
      const currentIndex = hotspotData.findIndex(h => h.focus_image_url === focus_image);

      // Pass the correct initialIndex to createBigDiv
      createBigDiv(focus_image, text, currentIndex);
    });

    createRipple();
  }


  // console.log('This is Toggle Button from InteriorHotspot', ToggleInteriorHotspots)

  document.addEventListener('DOMContentLoaded', () => {
    const hotspot = document.createElement('div');
    hotspot.style.width = '0px';
    hotspot.style.height = '0px';
    hotspot.style.backgroundColor = 'red';
    hotspot.style.position = 'absolute';
    hotspot.style.top = '100px';
    hotspot.style.left = '100px';
    document.body.appendChild(hotspot);

    setupHotspotTooltip(hotspot, 'This is a hotspot');


  });









  useEffect(() => {
    if (viewerRef.current) {
        const viewer = viewerRef.current.getViewer();

        // Add a small delay before rendering hotspots
        setTimeout(() => {
            (hotspotsJson || []).forEach((hotspot) => {
                const { yaw, pitch } = convertCoordinates(hotspot.coordinates.x, hotspot.coordinates.y);
            });
        }, 500);
    }
}, []);


// useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsAutoRotating(false);
//       if (viewerRef.current) {
//         viewerRef.current.getViewer().stopAutoRotate();
//       }
//     }, 1000);

//     return () => clearTimeout(timer);
//   }, []);




  const renderHotspots = (hotspotsData) => {
    return (hotspotsJson || []).map((hotspot) => {
      const { yaw, pitch } = convertCoordinates(hotspot.coordinates.x, hotspot.coordinates.y);
      // console.log("yaw and pitch", hotspot.reasons, yaw, pitch);

      // Check if yaw and pitch are valid numbers and not undefined or null
      if (isImageIdValid && typeof yaw === 'number' && !isNaN(yaw) && typeof pitch === 'number' && !isNaN(pitch)) {
        if(hotspot.type === 'tag')
        {
          return (
            <Pannellum.Hotspot
              key={hotspot.hotspot_id}
              type="custom"
              pitch={pitch}
              yaw={yaw}
              cssClass={`${Styles['custom-hotspot']} ${Styles['custom-hotspot-icon']}`}
              handleClick={(evt, args) => {
                // console.log(`Clicked hotspot: ${hotspot.hotspot_id}`);
              }}
              tooltip={(hotSpotDiv) => setupHotspotTooltip(hotSpotDiv, hotspot.focus_image_url, `${hotspot.reasons}`)}
              handleClickArg={{ name: hotspot.reasons }}
            />
          );
        }
        else
        {
          return (
            <Pannellum.Hotspot
              key={hotspot.hotspot_id}
              type="custom"
              pitch={pitch}
              yaw={yaw}
              cssClass={`${Styles['custom-hotspot']} ${Styles['custom-hotspot-icon-tag']}`}
              handleClick={(evt, args) => {
                // console.log(`Clicked hotspot: ${hotspot.hotspot_id}`);
              }}
              tooltip={(hotSpotDiv) => setupHotspotTooltip(hotSpotDiv, hotspot.focus_image_url, `${hotspot.reasons}`)}
              handleClickArg={{ name: hotspot.reasons }}
            />
          );
        }
        
      }
      // If yaw or pitch is not valid, don't render the hotspot
      return null;
    }).filter(Boolean); // Remove any null elements from the array
  };


  return (
    <>
{isMobileView && <div style={{ position: "absolute", height: "5vw", width: "10vw", zIndex: "111" }}>
                <InteriorMobileToggleHandler
                    ToggleInteriorHotspots={ToggleInteriorHotspots}
                    handlerMobileHotspot={handlerMobileHotspot}
                    setHandlerMobileHotspot={setHandlerMobileHotspot}
                    toggleHotspotVisibility={toggleHotspotVisibility}
                />
            </div>}
      {state?.interior360Url?.map((frames, index) => {
     if (state?.selectedUrl?.url !== (frames?.output_image_hres_url ? frames?.output_image_hres_url : frames?.input_image_hres_url)) return null;
        
    return (
          <div key={index} ref={containerRef}
            style={{
              width: isV2 ? "" : '100vw',
              height: '100vh',
              position: 'relative',
            }}
          >
            {isMobileView ? <Pannellum
             ref={viewerRef}
              width="100%"
              height="100%"
              hfov={50}
              image={`https://media.spyneai.com/unsafe/2400x1200/filters:format(webp)/${state?.selectedUrl?.url}`} 
              pitch={-20}
              yaw={-25}
              // haov={180}
              // vaov={180}
              autoLoad={true}
              autoRotate={5}
              showZoomCtrl={false}
              onError={handleError}
              showControls={false}

            >
              
              {(hotspotsJson?.interior_tagged_images?.hotspots || []) && renderHotspots(hotspotsJson[0]?.hotspots)}
            </Pannellum> :
              <Pannellum
              ref={viewerRef}
                width="100%"
                height="100%"
                hfov={120}
                image={`https://media.spyneai.com/unsafe/2400x1200/filters:format(webp)/${state?.selectedUrl?.url}`} 
                pitch={-30}
                yaw={-35}
                autoRotate={5}
                autoLoad={true}
                showZoomCtrl={false}
                onError={handleError}
                showControls={false}

              >

                
                {(hotspotsJson || []) && renderHotspots(hotspotsJson[0]?.hotspots)}
              </Pannellum>
            }
          </div>
        );
      })}
    </>
  );
};

export default InteriorIframe;
